import { render } from "./CallHistory.vue?vue&type=template&id=00b56fbd"
import script from "./CallHistory.vue?vue&type=script&lang=js"
export * from "./CallHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__